import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './SimplePage.css';
import ParticleCanvas from '../components/ui/ParticleCanvas';

const CATEGORIES = [
  {
    icon: '🚀',
    title: 'Getting Started',
    desc: 'Set up your first bot in under 5 minutes.',
    links: ['Quick Start Guide', 'Connect WhatsApp via QR', 'Train your AI', 'Invite team members'],
  },
  {
    icon: '🤖',
    title: 'AI & Knowledge Base',
    desc: 'Train and manage your AI chatbot.',
    links: ['Knowledge base overview', 'Uploading content', 'Testing your AI', 'Supported file types'],
  },
  {
    icon: '🛍️',
    title: 'E-Commerce',
    desc: 'Shopify and WooCommerce integrations.',
    links: ['Connect Shopify', 'Connect WooCommerce', 'Order confirmation flow', 'Follow-up sequences'],
  },
  {
    icon: '📊',
    title: 'LeadFlow Pipeline',
    desc: 'Managing your AI sales pipeline.',
    links: ['Pipeline overview', 'Stage configuration', 'Contact tags', 'CSV import'],
  },
  {
    icon: '📢',
    title: 'Broadcasts',
    desc: 'Sending bulk messages to your audience.',
    links: ['Creating a broadcast', 'Segmenting contacts', 'Scheduling messages', 'Tracking delivery'],
  },
  {
    icon: '⚙️',
    title: 'API & Webhooks',
    desc: 'Build custom integrations.',
    links: ['API authentication', 'Sending messages', 'Receiving webhooks', 'Rate limits'],
  },
];

export default function DocsPage() {
  return (
    <div className="simple-page">
      <SEO
        title="Documentation — Zepliq WhatsApp Automation Setup Guide"
        description="Zepliq documentation: learn how to connect WhatsApp, set up AI chatbots, integrate Shopify & WooCommerce, configure broadcasts, and use the Zepliq API. Step-by-step guides."
        keywords="Zepliq docs, WhatsApp bot setup guide, Zepliq documentation, WhatsApp automation tutorial, how to set up Zepliq, WhatsApp chatbot documentation, Zepliq API docs"
        canonical="/docs"
      />

      <section className="simple-hero">
        <ParticleCanvas className="simple-hero__canvas" />
        <div className="simple-hero__blob simple-hero__blob--1" aria-hidden="true" />
        <div className="simple-hero__blob simple-hero__blob--2" aria-hidden="true" />
        <div className="container simple-hero__inner">
          <span className="badge badge-brand">Documentation</span>
          <h1 className="display-xl simple-hero__title">
            Everything you need to<br />
            <span className="gradient-text">get the most from Zepliq.</span>
          </h1>
          <div className="docs-search">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
            <input type="text" placeholder="Search documentation..." className="docs-search__input" />
          </div>
        </div>
      </section>

      <section className="simple-section section">
        <div className="container">

          <div className="simple-grid-3">
            {CATEGORIES.map(cat => (
              <div key={cat.title} className="simple-card simple-card--docs">
                <span className="simple-card__emoji">{cat.icon}</span>
                <h3 className="simple-card__title">{cat.title}</h3>
                <p className="simple-card__desc">{cat.desc}</p>
                <ul className="docs-links">
                  {cat.links.map(link => (
                    <li key={link}>
                      <Link to="/contact" className="docs-link">
                        {link}
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="simple-divider" />

          <div className="simple-cta-box">
            <h2 className="display-md">Can't find what you need?</h2>
            <p className="text-lg">Our support team is available 24/7 to help you with any questions.</p>
            <div className="simple-cta-actions">
              <Link to="/contact" className="btn btn-primary btn-lg">Contact Support</Link>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
